import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

export const BaseAllergenSchema = z.object({
  allergen_id: uuidSchema,
  code: z.string().max(20),
  name: z.string().max(200),
  description: z.string().nullable().optional(),
  is_eu_14: z.boolean(),
  snomed_code: z.string().max(50).nullable().optional(),
  display_order: z.number().int().nullable().optional(),
  is_active: z.boolean(),
  created_at: z.string(),
});

export type BaseAllergen = z.infer<typeof BaseAllergenSchema>;

/** Schema used to parse raw Prisma rows (Date -> ISO string) before returning */
export const AllergenResponseSchema = BaseAllergenSchema.extend({
  created_at: z.coerce.date().transform((d) => d.toISOString()),
});

export type AllergenResponse = z.infer<typeof AllergenResponseSchema>;
